// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"1ed98a51","966":"baaedb2b"}[chunkId] + ".chunk.js";
};